import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../atomic/animations/brand/chevron-scroll.js";
import "../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../atomic/assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/overlay/modal.js";
import "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "../../atomic/text-lockup/date.js";
import { createTextLockupSmall } from "../../atomic/text-lockup/small.js";
const smallBreakpoint = token.media.breakpointValues.small.max;
const mediumBreakpointStart = token.media.breakpointValues.medium.min;
const mediumBreakpoint = token.media.breakpointValues.large.min;
const makeDateColumn = (dateSign) => new ElementBuilder().withClassName("card-list-date-sign-wrapper").withStyles({
  element: {
    width: `${token.spacing.xl}`,
    order: 1,
    alignSelf: "flex-start",
    ...createMediaQuery("max-width", mediumBreakpoint, {
      display: "none"
    }),
    ...createMediaQuery("min-width", mediumBreakpoint, {
      width: `${token.spacing["8xl"]}`
    })
  }
}).withChild(dateSign).build();
const makeTextColumn = (props) => {
  const lockup = createTextLockupSmall(props);
  return new ElementBuilder().withClassName("card-list-text-wrapper").withStyles({
    element: {
      flex: "1 0",
      ...createMediaQuery("min-width", mediumBreakpointStart, {
        paddingRight: `${token.spacing.md}`,
        order: "2"
      }),
      ...createMediaQuery("min-width", mediumBreakpoint, {
        width: "208px"
      })
    }
  }).withChild(lockup).build();
};
const makeImageColumn = ({
  image,
  isAligned
}) => {
  const backgroundImage = createImageBackground({
    element: image,
    isScaled: isAligned,
    isGifAllowed: false,
    imageLoading: "lazy"
  });
  return new ElementBuilder().withClassName("card-list-image-wrapper").withStyles({
    element: {
      ...createMediaQuery("max-width", smallBreakpoint, {
        marginLeft: token.spacing.min,
        marginBottom: token.spacing.md,
        width: "120px",
        float: "right",
        position: "relative",
        zIndex: 99,
        ...isAligned && {
          height: "104px"
        }
      }),
      ...createMediaQuery("min-width", mediumBreakpointStart, {
        display: "block",
        width: "160px",
        order: "3",
        ...isAligned && {
          height: "160px"
        }
      }),
      ...createMediaQuery("min-width", mediumBreakpoint, {
        width: "208px"
      }),
      "& img": {
        ...createMediaQuery("max-width", smallBreakpoint, {
          height: "auto !important"
        })
      }
    }
  }).withChild(backgroundImage).build();
};
const createCompositeCardList = (props) => {
  const { image, isAligned, isThemeDark, dateSign } = props;
  let children = [];
  if (image) {
    children.push(makeImageColumn({ image, isAligned }));
  }
  if (dateSign) {
    children.push(makeDateColumn(dateSign));
  }
  children.push(makeTextColumn(props));
  const wrapper = new ElementBuilder().withClassName("card-list-wrapper").withStyles({
    element: {
      containerType: "inline-size",
      ...createMediaQuery("min-width", mediumBreakpointStart, {
        display: "flex",
        justifyContent: "space-between"
      })
    }
  }).withChildren(...children).build();
  return new ElementBuilder().withClassName("card-list-container").withStyles({
    element: {
      height: "100%",
      overflow: "hidden",
      ...isThemeDark && {
        backgroundColor: token.color.black,
        color: token.color.white
      }
    }
  }).withChild(wrapper).build();
};
export {
  createCompositeCardList
};
//# sourceMappingURL=list.js.map
